import { render, staticRenderFns } from "./CreateMdModel.vue?vue&type=template&id=7b81ee8e"
import script from "./CreateMdModel.vue?vue&type=script&lang=js"
export * from "./CreateMdModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports